// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1LDuF","content":"styles_content__2cnox","checkbox":"styles_checkbox__3_33I","checkboxLabel":"styles_checkboxLabel__4Htmr"};